import React,{useState,useEffect} from 'react';
import './chat.css';
import axios from 'axios';

function Chat(){
   const [messages, setMessages] = useState([]);
   const [input,setshowinput]=useState(false);
   const [inputvalue,setinputvalue]=useState(''); 
   const [isOpen,setIsOpen]=useState(false);

  useEffect(() => {
    startChat();
  }, []);
    
    const startChat = () => {
    let arr = [];

    arr.push({
      sender: "bot",
      text: "Hi there! Welcome to Pranati Interior Pvt Ltd - India’s most trusted brand."
    });

    arr.push({
      sender: "bot",
      text: "How can I help you today?"
    });

    arr.push({
      sender: "options",
      options: [
        "Get Free Quote",
        "Talk to Designer",
        "Ongoing Project Query"
      ]
    });

    setMessages(arr);
  };

  const handleClick = (option) => {
    let arr = [];

  
    for (let i = 0; i < messages.length; i++) {
      arr.push(messages[i]);
    }

    
    arr.push({
      sender: "user",
      text: option
    });

 
    if (option === "Get Free Quote") {
      arr.push({
        sender: "bot",
        text: "Great! Our team will help you with a free quote."
      });

    setshowinput(true);
    }

    if (option === "Talk to Designer") {
      arr.push({
        sender: "bot",
        text: "Connecting you with a designer shortly."
      });
       setshowinput(true);
    }

    if (option === "Ongoing Project Query") {
      arr.push({
        sender: "bot",
        text: "What would you like us to help you with?"
      });

      arr.push({
        sender: "options",
        options: ["Project-related query", "Project escalation"]
      });
    }

    if (option === "Project-related query") {
      arr.push({
        sender: "bot",
        text: "Please share your registered email address."
      });

      setshowinput(true);
    }

    if (option === "Project escalation") {
      arr.push({
        sender: "bot",
        text: "Our escalation team will contact you soon."
      });
    }

    setMessages(arr);
  };


  const handlesend=async()=>{
    try{
     const res = await axios.post(
        `https://api.squareandangle.pranatigroup.in/api/admin/savechat`,
        {
          email: inputvalue,
          message: 'Need design related Query',
        },
        {
          headers: {
            "Content-type": "application/json",
          },
        }
      );
      alert('Thanks for query');
      setinputvalue("");
      setshowinput(false);
    }catch(error){
     console.log("DB Error:", error);
    }
    
  }

 
  const renderMessages = () => {
    let ui = [];

    for (let i = 0; i < messages.length; i++) {
      let msg = messages[i];

      if (msg.sender === "bot") {
        ui.push(
          <div key={i} className="bot">
            {msg.text}
          </div>
        );
      }

      if (msg.sender === "user") {
        ui.push(
          <div key={i} className="user">
            {msg.text}
          </div>
        );
      }

      if (msg.sender === "options") {
        ui.push(
          <div key={i} className="options">
            {msg.options[0] && (
              <button onClick={() => handleClick(msg.options[0])}>
                {msg.options[0]}
              </button>
            )}
            {msg.options[1] && (
              <button onClick={() => handleClick(msg.options[1])}>
                {msg.options[1]}
              </button>
            )}
            {msg.options[2] && (
              <button onClick={() => handleClick(msg.options[2])}>
                {msg.options[2]}
              </button>
            )}
          </div>
        );
      }
    }

    return ui;
  };

  return(
    <>
    {!isOpen && (
         <div className="chat-launcher" onClick={() => setIsOpen(true)}>
          💬
          <span className="online">We are online</span>
        </div>
    )}

    {isOpen && (
        <div className="chat-container">
          <div className="chat-header">
            <span>Pranati Interior</span>
            <button onClick={()=>setIsOpen(false)} style={{borderRadius: '20px',
    backgroundColor: '#f0f0f0',
    padding: '5px 10px',
    cursor: 'pointer'
            }}>✕</button>
            </div>
            <div className="chatBox">{renderMessages()}</div>
            {input && (
             <div className="inputBox">
            <input
              type="text"
              placeholder="Enter email..."
              value={inputvalue}
              onChange={(e) => setinputvalue(e.target.value)}
            />              
            <button onClick={handlesend}>Send</button>
            </div>
            )}
            </div>
    )}
    
    </>
  ) 




  
  
  
}

export default Chat;



